import { render, staticRenderFns } from "./OtherHolders.vue?vue&type=template&id=7ed1b6c8"
import script from "./OtherHolders.vue?vue&type=script&lang=js"
export * from "./OtherHolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports